module.exports = __webpack_public_path__ + "img/fossilImg2.fc5cfc62.jpg";